import { Component } from "react";
import Utility, { deepClone } from "../../utility/Utility";
import { GOAL_FILTER, GOAL_FILTER_CONSTANT, GOAL_FORM_FIELD, GOAL_PRIORITY } from "./PerformanceConstant";
import {
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    DKIcons,
    DKLabel,
    DKIcon,
    DKSpinner,
    DKTooltipWrapper,
    DKInput,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import Popup from "../common/Popup";
import { Store } from "../../Redux/Store";
import { fetchUsers } from "../../Redux/Slices/PayrollSlice";
import EmployeeListService from "../../services/EmployeeListService";
import PerformaceService from "../../services/PerformaceService";
import moment from "moment";
import { connect } from "react-redux";
import { COLUMN_CODE } from "../../managers/TableManger";
import PayrollService from "../../services/PayrollService";
import AttendanceService from "../../services/AttendanceService";
import { TENANT, TenantService } from "../../managers/TenantManagerService";

class CreateGoal extends Component {
    goalFormField = deepClone(GOAL_FORM_FIELD);
    goalFilters = deepClone(GOAL_FILTER)
    allUsers = [];
    teamData = [];
    designations = [];
    dataForEdit = null
    goalData = {
        "id": null,
        "name": "",
        "description": "",
        "startDate": "",
        "dueDate": "",
        "priority": GOAL_PRIORITY[0],
        "filter": this.goalFilters[0],
        "specificTeam":"",
        "specificDesignation":"",
        "applicableTo": []
    }
    isManager = TenantService.get(TENANT.IS_MANAGER) && !TenantService.get(TENANT.IS_ADMIN)
    isAdmin =  TenantService.get(TENANT.IS_ADMIN)
    constructor(props) {
        super(props);
        if(this.isManager) {
            this.goalFilters = this.goalFilters.filter(g=>g.id !== GOAL_FILTER_CONSTANT.DESIGNATION)
        }
        if (this.props.data) {
            this.dataForEdit = deepClone(this.props.data);
            this.goalData = deepClone(this.props.data)
            this.goalData['startDate'] = new Date(this.goalData['startDate'])
            this.goalData['dueDate'] = new Date(this.goalData['dueDate'])
            delete this.goalData.applicableTo
            this.goalData['priority'] = GOAL_PRIORITY.find(g => g.id == (this.props.data.priority.id||this.props.data.priority));
            this.goalData['filter'] =  this.goalFilters.find(g => g.id == (this.props.data?.applicability?.filter?.id||this.props.data?.applicability?.filter)) || this.goalFilters[0];
            this.goalData['specificDesignation'] = this.props.data?.applicability?.designation ? 
                                                    { 
                                                        id:this.props.data?.applicability?.designation,
                                                        name:this.props.data?.applicability?.designation
                                                    }:''
        }
        this.getUsers()
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    renderHeader() {
        return (
            <div className="row justify-content-between mb-m">
                <DKLabel className="fw-m fs-m" text={`${this.dataForEdit ? "Edit ": "Create"} Goal`} />
                <div className="d-flex ">
                    <DKButton className="bg-gray1 border-m" title="Cancel" onClick={() => this.props.onClose()} />
                    <DKButton className="bg-app text-white ml-m" title="Submit" onClick={() => this.submit()} />
                </div>
            </div>
        )
    }
    prepareDataBeforeSubmit() {
        const user = this.goalFormField.find(f=>f.columnCode === "applicableTo")
        let finalObject = {
            ...this.goalData,
            priority: this.goalData.priority.id,
            dueDate: `${moment(this.goalData.dueDate).format("YYYY-MM-DD")}`,
            startDate: `${moment(this.goalData.startDate).format("YYYY-MM-DD")}`,
            applicability: {
                "filter": this.goalData?.filter?.id,
                "teamId": this.goalData?.specificTeam?.id,
                "designation": this.goalData?.specificDesignation?.id,
                "users": this.goalData?.filter?.id  === GOAL_FILTER_CONSTANT.SPECIFIC?  this.goalData.applicableTo.map(a => parseInt(user?.options[a]?.iamUserId)) || [] : []
            },
        }
        delete finalObject.applicableTo;
        delete finalObject.filter;
        delete finalObject.specificDesignation;
        delete finalObject.specificTeam;
        return finalObject;
    }
    validateForm() {
        let isValid = true;
        this.canValidate = true;
        this.goalFormField.filter(f=>!f.hidden).forEach(field => {
            if (field.required && field.type != INPUT_TYPE.NUMBER && Utility.isEmpty(this.goalData[field.key])) {
                isValid = false;
            } else if (field.required && field.type == INPUT_TYPE.NUMBER && Utility.isEmpty(this.goalData[field.key].toString()) ) {
                isValid = false;                
            } else if (!field.isValid) {
                isValid = false;
            }
        })
        this.updateState();
        return isValid
    }
    submit() {
        if (!this.validateForm()) {
            return;
        }
        let param = this.prepareDataBeforeSubmit();
        const api = this.dataForEdit ? PerformaceService.updateGoals(param, this.dataForEdit.id):PerformaceService.saveGoals(param)
        this.dataForEdit ? showLoader('Updating Goal... Please wait.') : showLoader('Saving Goal... Please wait.')
        api.then(res => {
            if (this.dataForEdit) {
                showToast('Goal is updated successfully', TOAST_TYPE.SUCCESS)
            } else {
                showToast('Goal is saved successfully', TOAST_TYPE.SUCCESS)
            }
            removeLoader()
            this.props.onClose(true)
        }, error => {
            if(error?.errorMessage) {
                showToast(error?.errorMessage, TOAST_TYPE.FAILURE)
            }
            
            removeLoader()
        })
    }
    getFieldValue(obj) {
        switch (obj.columnCode) {

            default:
                return this.goalData[obj.columnCode]
        }

    }
    onChange(value, index, obj) {
        switch (obj.key) {
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.FILTER:
                this.goalData['specificTeam'] = '';
                this.goalData['specificDesignation'] = '';
                this.goalData[obj.key] = value;
                switch(value.id) {
                    case GOAL_FILTER_CONSTANT.SPECIFIC:
                        this.getUsers();
                        break;
                    case GOAL_FILTER_CONSTANT.DESIGNATION:
                        this.getUserByDesignation();
                        break;
                    case GOAL_FILTER_CONSTANT.TEAM:
                        this.getUserByTeam();
                        break;
                }
                break;
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.SPECIFIC_TEAM:
                let alteredConfig = [];
                alteredConfig.push({
                    columnCode: 'applicableTo',
                    options: value.members.map(m=>{
                        return {
                            ...m,
                            name: m.firstName+ " "+m.lastName
                        }
                    }),
                    readOnly: false
                })
                
                this.goalData.applicableTo = [];
                this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, alteredConfig, false)
                this.goalData[obj.key] = value;
                break;
            case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.SPECIFIC_DESIGNATION:
                let designationAlteredConfig = [];
                
                designationAlteredConfig.push({
                    columnCode: 'applicableTo',
                    options: this.allUsers.filter(a=> a.designation === value.id),
                    readOnly: false
                })
                
                this.goalData.applicableTo = [];
                this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, designationAlteredConfig, false)
                this.goalData[obj.key] = value;
            default:
                this.goalData[obj.key] = value;
                break;
        }
        this.updateState()
    }
    async getUsers() {
        const isTeamSpecific = this.goalData['filter'] && this.goalData['filter'].id === GOAL_FILTER_CONSTANT.TEAM
        const isDesignationSpecific = this.goalData['filter'] && this.goalData['filter'].id === GOAL_FILTER_CONSTANT.DESIGNATION
        if (!Utility.isEmpty(this.props.userDetails) && this.props.userDetails['users']) {
            this.allUsers =  await this.props.userDetails['users'];
            if (this.isManager) {
                this.filterManagerWiseTeam();
            }
            let alteredConfig = [];
            if(this.isManager) {
                alteredConfig.push({ columnCode: 'filter', options:this.goalFilters })
            }
            alteredConfig.push({ columnCode: 'specificTeam', hidden: !isTeamSpecific, options:this.teamData })
            alteredConfig.push({ columnCode: 'specificDesignation', hidden: !isDesignationSpecific, options: this.designations })
            if(isTeamSpecific) {
                alteredConfig.push({ columnCode: 'applicableTo', options: this.allUsers, readOnly: false })
                this.getUserByTeam(true)
            } else if(isDesignationSpecific && !this.isManager) {
                if(this.goalData['specificDesignation'].id) {
                    const user = this.allUsers.filter(a=> a.designation === this.goalData['specificDesignation'].id)
                    alteredConfig.push({ columnCode: 'applicableTo', options: user, readOnly: false })
                } else {
                    alteredConfig.push({ columnCode: 'applicableTo', options: this.allUsers, readOnly: false })

                }
                this.getUserByDesignation(true)
            } else {
                const users =  this.allUsers;
                alteredConfig.push({ columnCode: 'applicableTo', options: users, readOnly: false,hidden: false })
                this.setApplicableTo(this.allUsers);
                this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, alteredConfig, false)
                this.updateState()
            }
            
        } else {

            const getUsers = async () => {
                if(!this.isManager && this.isAdmin) {
                    const response = await this.props.fetchUsers();
                
                    if (response && response['error']) {
                        showToast((response['message'] ? response['message'] : "Unable to Load user."), TOAST_TYPE.FAILURE);
                        this.setState({
                            ...this.state,
                            isLoadingApprovalDetails: false
                        })
                    }
                }
                if ( 
                    (!Utility.isEmpty(this.props.userDetails) 
                    && this.props.userDetails['users']
                    ) ||
                    this.isManager
                ) {

                    this.allUsers = await this.props.userDetails['users'];
                    if (this.isManager) {
                        this.filterManagerWiseTeam();
                    }
                    let alteredConfig = [];
                    if(this.isManager) {
                        alteredConfig.push({ columnCode: 'filter',  options:this.goalFilters })
                    }
                    alteredConfig.push({ columnCode: 'specificTeam', hidden: !isTeamSpecific, options: this.teamData})
                    alteredConfig.push({ columnCode: 'specificDesignation', hidden: !isDesignationSpecific, options: this.designations })
                    if (isTeamSpecific ) {
                        alteredConfig.push({ columnCode: 'applicableTo', options: this.allUsers, readOnly: false,hidden:true })
                        this.getUserByTeam(true)
                    } else if (isDesignationSpecific && !this.isManager) {
                        if(this.goalData['specificDesignation'].id) {
                            const user = this.allUsers.filter(a=> a.designation === this.goalData['specificDesignation'].id)
                            alteredConfig.push({ columnCode: 'applicableTo', options: user, readOnly: false,hidden:true })
                        } else {
                            alteredConfig.push({ columnCode: 'applicableTo', options: this.allUsers, readOnly: false,hidden:true })

                        }
                        
                        this.getUserByDesignation(true)
                    } else {
                        const users = this.allUsers
                        alteredConfig.push({ columnCode: 'applicableTo', options: users, readOnly: false,hidden:false })
                        this.allUsers = await this.props.userDetails['users'];
                        if (this.isManager) {
                            this.filterManagerWiseTeam();
                        }
                        this.setApplicableTo(this.allUsers);
                        this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, alteredConfig, false)
                        this.updateState()
                    }
                }
            }
            await getUsers();

        }
    }
    setApplicableTo(users) {
        if (this.dataForEdit) {
            let index = []
            this.dataForEdit?.applicability?.users?.forEach(a => {
                index.push(users?.findIndex(u => u.iamUserId == a))
            })
            this.goalData.applicableTo = index
        }

    }
    getUserByDesignation(isInit) {
        if(Utility.isEmpty(this.designations)) {
            showLoader()
            AttendanceService.getDesignation().then(response=>{
                removeLoader()
                if(response['designations']) {
                  this.designations = response['designations'].filter(res=>res !="").map(d=>{
                      return {
                        id:d,
                        name:d
                      }
                  });
                  this.setApplicableToByDesignation(isInit)
                }
            },error=>{
                removeLoader();
            })
        } else {
            this.setApplicableToByDesignation(isInit)
        }
    }
    setApplicableToByDesignation(isInit) {
        
        let alteredConfig = [];
        
        alteredConfig.push({ columnCode: 'specificTeam', hidden: true })
        alteredConfig.push({ columnCode: 'specificDesignation', hidden: false, options: this.designations })
        
        if(!isInit) {
            this.goalData.applicableTo = [];
            alteredConfig.push({ columnCode: 'applicableTo',options:this.allUsers, readOnly:true, hidden:true })
        } else {
            this.goalData['specificDesignation'] = this.designations?.find(g => g.id == (this.props.data.applicability?.designation?.id||this.props.data.applicability?.designation));
            
            const user = this.allUsers.filter(a=> a.designation === this.goalData['specificDesignation']?.id)
            alteredConfig.push({
                columnCode: 'applicableTo',
                options: user,
                readOnly: false,
                hidden:true
            })
            setTimeout(()=>{
                this.setApplicableTo(user);
                this.updateState()
            },100)
        }
        this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, alteredConfig, false)
        this.updateState()
    }
    async getUserByTeam(isInit) {
        if(Utility.isEmpty(this.teamData)) {
            if (this.isManager) {
                const filterTeamWithManager = this.filterManagerWiseTeam() || [];
                this.teamData = filterTeamWithManager?.map(t => {
                    return {
                        ...t,
                        id: t.teamId,
                        members: t.members.map(m => {
                            return {
                                ...m,
                                name: m.firstName + " " + m.lastName
                            }
                        })
                    }
                }) || []
            } else {
                showLoader()
                const response = await PayrollService.getTeams();
                removeLoader()
                this.teamData = response?.teams?.map(t => {
                    return {
                        ...t,
                        id: t.teamId,
                        members: t.members.map(m => {
                            return {
                                ...m,
                                name: m.firstName + " " + m.lastName
                            }
                        })
                    }
                }) || []
            }
            
        }
        
        let alteredConfig = [];
        
        alteredConfig.push({ columnCode: 'specificTeam', hidden: false, options: this.teamData })
        alteredConfig.push({ columnCode: 'specificDesignation', hidden: true, options: this.designations })
        
        
        if(!isInit) {
            this.goalData.applicableTo = []; 
            alteredConfig.push({ columnCode: 'applicableTo', options: this.allUsers, readOnly: true, hidden: true  })
        } else {
            if(this.props.data?.applicability?.teamId) {
                this.goalData['specificTeam'] = this.teamData.find(g => g.id == this.props.data?.applicability?.teamId)
                setTimeout(()=>{
                    this.setApplicableTo(this.goalData['specificTeam'].members);
                    this.updateState()
                },100)
            }
            
            alteredConfig.push({ columnCode: 'applicableTo', options: this.goalData['specificTeam']?.members || this.allUsers, readOnly: false, hidden: true })
        }    
        this.goalFormField = EmployeeListService.getAlteredConfigDetails(this.goalFormField, alteredConfig, false)
        this.updateState()
    }
    filterManagerWiseTeam() {
        let teamData = [];
        this.allUsers = []
        teamData = TenantService.get(TENANT.TEAMS) || [];
        let filterTeamWithManager = [];
        teamData?.forEach((team) => {
            const member = team?.members?.find(m => (m.iamUserId == TenantService.get(TENANT.IAM_USER_ID) && m.roles[0] === 'MANAGER'));
            if (member) {
                this.allUsers = [...this.allUsers, ...team.members]
                let commonFilterUser = []
                this.allUsers.forEach((u,index)=>{
                    if(this.allUsers.findIndex(a=>a.iamUserId === u.iamUserId) === index) {
                        commonFilterUser.push(u)
                    }
                })
                this.allUsers = commonFilterUser||[]
                filterTeamWithManager.push(team)
            }
        });
        return filterTeamWithManager
    }
    renderFields(obj, index) {
        return (
            <>
                <DKInput

                    className={"p-v-s mb-r"}
                    icon={obj.icon}
                    title={obj?.name}
                    placeholder={obj?.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate || obj['canValidate']}
                    onChange={(value) => {
                        obj['canValidate'] = true;
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else if(obj.columnCode == 'startDate' && !Utility.isEmpty(this.goalData["dueDate"])) {
                            let field1 = moment(value);
                            let dob = moment(this.goalData["dueDate"]);
                            if (!Utility.isEmpty(field1) && moment(dob).isSameOrAfter(field1)) {
                                obj.isValid = true;
                                return true
                            } else {
                                obj.isValid = false;
                                return false
                            }
                        } else if(obj.columnCode == 'dueDate' && !Utility.isEmpty(this.goalData["startDate"])) {
                            let field1 = moment(this.goalData["startDate"]);
                            let dob = moment(value);
                            if (!Utility.isEmpty(field1) && moment(dob).isSameOrAfter(field1)) {
                                obj.isValid = true;
                                return true
                            } else {
                                obj.isValid = false;
                                return false
                            }
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return obj?.name;
                    }}
                    displayKey={"name"}
                    dropdownConfig={{
                        className: "",
                        checkMarkColor: "bg-app",
                        style: {},
                        searchableKey:"name",
                        allowSearch :obj.options?.length > 6 ? true:false,
                        multiSelect: obj.multiSelect,
                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj?.name}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />
            </>
        )
    }
    renderForm() {
        try {
            return this.goalFormField.filter(f=>!f.hidden).map(f => this.renderFields(f))
        } catch (error) {
            return ''
        }
        
    }
    render() {
        return (
            <>
                <Popup className="" >
                    {/* style={{ overflow: 'visible'}} */}
                    {this.renderHeader()}
                    <div className="pb-xxl">
                        {this.renderForm()}
                    </div>
                </Popup>
            </>
        )
    }
}
const mapStateToProps = (state) => ({
    userDetails: state?.payroll?.formData?.usersList || {}
})

const mapDispatchToProps = { fetchUsers };

export default connect(mapStateToProps, mapDispatchToProps)(CreateGoal);